import { Check } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { PASSWORD_REQUIREMENTS } from '@avanta/shared/constants/validations';
import { cn } from '@avanta/shared/utils/cn';

interface PasswordRequirementProps {
  password: string;
}

export const PasswordRequirement = ({ password }: PasswordRequirementProps): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.AUTH);

  return (
    <ul className="mt-2 space-y-1 list-none">
      {PASSWORD_REQUIREMENTS.map(({ test, requirementKey }) => {
        const valid = test(password);
        return (
          <li
            key={requirementKey}
            className={cn(
              'flex items-center gap-2 text-xs transition-colors',
              valid ? 'text-teal-600' : 'text-gray-500'
            )}
          >
            <Check
              className={cn('h-3 w-3 shrink-0', valid ? 'opacity-100' : 'opacity-0')}
              aria-hidden
            />
            <span>{t(requirementKey)}</span>
          </li>
        );
      })}
    </ul>
  );
};
